import { Configuration, FetchAPI } from 'api-client';

import { authInstance } from '../index';

export const fetchApi: FetchAPI = async (input, init) => {
    const [account] = authInstance.getAllAccounts();
    const clientId = authInstance.getConfiguration().auth.clientId;
    const accessTokenResponse = await authInstance.acquireTokenSilent({
        account,
        scopes: [`${clientId}/.default`],
    });
    const headers = new Headers(init?.headers);
    headers.append("Authorization", `Bearer ${accessTokenResponse.accessToken}`);

    const options = {
        headers: headers,
    };
    return await fetch(input, { ...init, ...options });
};
export const getAuthConfiguration = (apiBaseUrl: string) => {
    const configuration = new Configuration({
        basePath: apiBaseUrl,
        fetchApi,
    });
    return configuration;
};

export const getMyProfilePicture = async () => {
    const [account] = authInstance.getAllAccounts();
    const accessTokenResponse = await authInstance.acquireTokenSilent({
        account,
        scopes: ["https://graph.microsoft.com/User.Read"],
    });
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${accessTokenResponse.accessToken}`);

    const options = {
        headers: headers,
    };
    return await fetch("https://graph.microsoft.com/v1.0/me/photos/120x120/$value", { ...options })
        .then(response => {
            if (!response.ok) {
                throw new Error("Failed to get profile picture");
            }
            return response.blob();
        })
        .then(blob => URL.createObjectURL(blob));
};
